import React from "react";
import { useState } from "react";
import {
  CardComp,
  ModalCompAdvanceUpdate,
  TabsComp,
} from "../../../components";
import FilterFind from "../../../components/FilterFind";
import Message from "../../../components/MessageModal";
import AllLoanStatus from "./modules/AllLoanStatus";
import {
  useGetPendingLoansRequestssQuery,
  useGetApprovedLoansListQuery,
  useGetDeclinedLoansListQuery,
  useGetDisbursedLoansListQuery,
  useGetPaidLoansListQuery,
  useApproveLoanRequestMutation,
  useResendGuarantorInvitationsMutation,
} from "../../../store/admin/loan";
import toast from "react-hot-toast";
import DisburseLoanModal from "./modal/disburse-loan-modal";
import DeclineLoanModal from "./modal/decline-loan-modal";
import ViewLoanDetailsModal from "./modal/view-loan-details-modal";
import ManageGuarantorsModal from "./modal/manage-guarantors-modal";
import { useNavigate } from "react-router-dom";
import { convertToTitleCase } from "../../../utils/helpers";

export default function LoanStatus() {
  const navigate = useNavigate();
  const [modalPage, setModalPage] = useState("");
  const [requestId, setRequestId] = useState("");
  const [pendingLoanPage, setPendingLoanPage] = useState(1);
  const [approvedLoanPage, setApprovedLoanPage] = useState(1);
  const [declinedLoanPage, setDeclineLoanPage] = useState(1);
  const [disbursedLoanPage, setDisbursedLoanPage] = useState(1);
  const [paidLoanPage, setPaidLoanPage] = useState(1);

  const {
    data: pendingLoans,
    isLoading: isLoadingPendingLoans,
    isFetching,
  } = useGetPendingLoansRequestssQuery(pendingLoanPage);

  const { data: approvedLoans, isLoading: isLoadingApproveLoans } =
    useGetApprovedLoansListQuery(approvedLoanPage);

  const { data: declinedLoans, isLoading: isLoadingDeclineLoans } =
    useGetDeclinedLoansListQuery(declinedLoanPage);

  const { data: disbursedLoans, isLoading: isLoadingDisburseLoans } =
    useGetDisbursedLoansListQuery(disbursedLoanPage);

  const { data: paidLoans, isLoading: isLoadingPaidLoans } =
    useGetPaidLoansListQuery(paidLoanPage);

  const [isApproveRequest, { isLoading: isApprovingLoans }] =
    useApproveLoanRequestMutation();
  const [resendGuarantorInvitations, { isLoading: isResendingInvitations }] =
    useResendGuarantorInvitationsMutation();

  const handleApproveLoanRequest = async (requestId) => {
    const response = await isApproveRequest(requestId);
    const { error, message, status } = response?.data;
    if (!status) return toast.error(message);
    toast.success(message);
    setModalPage();
    if (error) return toast.error(error?.data?.message);
  };

  const handleResendGuarantorInvitations = async (requestId) => {
    try {
      const response = await resendGuarantorInvitations(requestId).unwrap();
      if (response.status) {
        toast.success(response.message || "Invitation emails sent successfully");
        setModalPage();
      } else {
        toast.error(response.message || "Failed to send invitation emails");
      }
    } catch (error) {
      toast.error(error?.data?.message || "Failed to send invitation emails");
    }
  };

  // Status badge function
  const getStatusBadge = (row) => {
    return (
      <div
        className="px-3 py-1 rounded-pill text-white text-center"
        style={{
          backgroundColor:
            row?.status === "PENDING"
              ? "#FFA500"
              : row?.status === "APPROVED"
              ? "#19BC31"
              : row?.status === "DECLINED"
              ? "#FF4343"
              : row?.status === "DISBURSED"
              ? "var(--color-secondary)"
              : row?.status === "PAID"
              ? "#19BC31"
              : "#A1A0A0",
        }}
      >
        {convertToTitleCase(row?.status === "PAID" ? "Completed" : row?.status || "UNKNOWN")}
      </div>
    );
  };

  const ButtonArrayPendingLoan = (row) => {
    return [
      {
        name: "Approve",
        action: () => {
          setModalPage("Approve Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "Decline",
        action: () => {
          setModalPage("Decline Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "Resend Invitation",
        action: () => {
          setModalPage("Resend Invitation Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "Manage Guarantors",
        action: () => {
          setModalPage("Manage Guarantors Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "View Details",
        action: () => {
          setModalPage("View Details Modal");
          setRequestId(row.id);
        },
      },
    ];
  };
  const ButtonArrayApproveLoan = (row) => {
    return [
      {
        name: "Disburse loan",
        action: () => {
          setModalPage("Disburse Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "View Details",
        action: () => {
          setModalPage("View Details Modal");
          setRequestId(row.id);
        },
      },
    ];
  };
  const ButtonArrayDeclineLoan = (row) => {
    return [
      {
        name: "Reconsider loan",
        action: () => {
          setModalPage("Reconsider Modal");
          setRequestId(row.id);
        },
      },
      {
        name: "View Details",
        action: () => {
          setModalPage("View Details Modal");
          setRequestId(row.id);
        },
      },
    ];
  };
  const ButtonArrayDisbursedLoan = (row) => {
    return [
      {
        name: "View repayment plan",
        action: () => {
          navigate(`/super_admin/loan_management/loan_repayment/${row.id}`);
        },
      },
      {
        name: "View Details",
        action: () => {
          setModalPage("View Details Modal");
          setRequestId(row.id);
        },
      },
    ];
  };

  const ButtonArrayPaidLoan = (row) => {
    return [
      {
        name: "View repayment plan",
        action: () => {
          navigate(`/super_admin/loan_management/loan_repayment/${row.id}`);
        },
      },
      {
        name: "View Details",
        action: () => {
          setModalPage("View Details Modal");
          setRequestId(row.id);
        },
      },
    ];
  };

  const useModal = [
    {
      name: "Approve Modal",
      component: (
        <Message
          title={"Confirm"}
          loading={isApprovingLoans}
          desc={"Are  you sure you want to approve this loan?"}
          onBack={() => setModalPage()}
          onProceed={() => handleApproveLoanRequest(requestId)}
        />
      ),
    },
    {
      name: "Reconsider Modal",
      component: (
        <Message
          title={"Confirm"}
          loading={isApprovingLoans}
          desc={"Are  you sure you want to reconsider this loan for approval?"}
          onBack={() => setModalPage()}
          onProceed={() => handleApproveLoanRequest(requestId)}
        />
      ),
    },
    {
      name: "Decline Modal",
      component: (
        <DeclineLoanModal requestId={requestId} setModalPage={setModalPage} />
      ),
    },
    {
      name: "Disburse Modal",
      component: (
        <DisburseLoanModal requestId={requestId} setModalPage={setModalPage} />
      ),
    },
    {
      name: "View Details Modal",
      component: (
        <ViewLoanDetailsModal
          requestId={requestId}
          setModalPage={setModalPage}
        />
      ),
    },
    {
      name: "Resend Invitation Modal",
      component: (
        <Message
          title={"Resend Guarantor Invitations"}
          loading={isResendingInvitations}
          desc={"Are you sure you want to resend invitation emails to all pending guarantors? This will only send emails to guarantors who have not yet confirmed or declined."}
          onBack={() => setModalPage()}
          onProceed={() => handleResendGuarantorInvitations(requestId)}
        />
      ),
    },
    {
      name: "Manage Guarantors Modal",
      component: (
        <ManageGuarantorsModal
          requestId={requestId}
          setModalPage={setModalPage}
        />
      ),
    },
  ];
  const useTab = [
    {
      name: "Pending loan",
      component: (
        <AllLoanStatus
          name="pending loan"
          ButtonArray={ButtonArrayPendingLoan}
          StatusBadgeArray={getStatusBadge}
          TableData={pendingLoans?.data?.company_loan_requests || []}
          pagination={pendingLoans?.data?.pagination}
          loading={isLoadingPendingLoans || isFetching}
          setPageNumber={setPendingLoanPage}
        />
      ),
    },
    {
      name: "Approved loan",
      component: (
        <AllLoanStatus
          name="approved loan"
          ButtonArray={ButtonArrayApproveLoan}
          StatusBadgeArray={getStatusBadge}
          TableData={approvedLoans?.data?.company_loan_requests || []}
          pagination={approvedLoans?.data?.pagination}
          loading={isLoadingApproveLoans}
          setPageNumber={setApprovedLoanPage}
        />
      ),
    },
    {
      name: "Declined loan",
      component: (
        <AllLoanStatus
          name="declined loan"
          ButtonArray={ButtonArrayDeclineLoan}
          StatusBadgeArray={getStatusBadge}
          TableData={declinedLoans?.data?.company_loan_requests || []}
          pagination={declinedLoans?.data?.pagination}
          loading={isLoadingDeclineLoans}
          setPageNumber={setDeclineLoanPage}
        />
      ),
    },
    {
      name: "Disbursed loan",
      component: (
        <AllLoanStatus
          name="disbursed loan"
          ButtonArray={ButtonArrayDisbursedLoan}
          StatusBadgeArray={getStatusBadge}
          modalPage={modalPage}
          useModal={useModal}
          TableData={disbursedLoans?.data?.company_loan_requests || []}
          pagination={disbursedLoans?.data?.pagination}
          loading={isLoadingDisburseLoans}
          setPageNumber={setDisbursedLoanPage}
        />
      ),
    },
    {
      name: "Completed loan",
      component: (
        <AllLoanStatus
          name="completed loan"
          ButtonArray={ButtonArrayPaidLoan}
          StatusBadgeArray={getStatusBadge}
          modalPage={modalPage}
          useModal={useModal}
          TableData={paidLoans?.data?.company_loan_requests || []}
          pagination={paidLoans?.data?.pagination}
          loading={isLoadingPaidLoans}
          setPageNumber={setPaidLoanPage}
        />
      ),
    },
  ];

  return (
    //
    <section className=" px-lg-3 min-vh-100 ">
      <div data-tour="staff-loan-status-header">
        <FilterFind title={"Loan Status"} rightSide={false} />
      </div>

      <div data-tour="staff-loan-status-table">
      <CardComp>
        <div className="py-4"></div>
        <ModalCompAdvanceUpdate
          pageName={modalPage}
          arrayComp={useModal}
          handleClose={() => setModalPage()}
          centered
          size={modalPage === "View Details Modal" || modalPage === "Manage Guarantors Modal" ? "xl" : "md"}
        />
        <div data-tour="staff-loan-status-tabs">
          <TabsComp
            TabArray={useTab}
            input="name"
            justifyContent={"justify-content-start"}
            tabClassName="px-0"
            TabArrayClassName="px-4"
          />
        </div>
      </CardComp>
      </div>
    </section>
  );
}
